import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { initCompanyData } from '../../actions/company/index';
import { forwardLogin } from '../../actions/login/index';
import CompanyInfoForm from '../../components/maintenance/CompanyInfoForm';
import Loading from '../../components/common/Loading';

class CompanyInfoPage extends Component {
  renderList = () => {
    const { loading } = this.props;

    let displayList;
    if (loading) {
      displayList = <Loading loading={loading}></Loading>;
    } else {
      displayList = <CompanyInfoForm></CompanyInfoForm>;
    }

    return (
      <div className='custom-list company-list'>
        {displayList}
      </div>
    )
  }

  componentDidMount() {
    const { idToken, initCompanyData, companyInfo } = this.props;
    if (companyInfo.loading) {
      if (idToken) {
        initCompanyData(idToken, 'Pacific');
      }
    }
  }
  
  // componentDidUpdate (prevProps, prevState, snapshot) {
    // const { forwardLogin, status, history } = this.props;
    // if (prevProps.status !== status) {
    //   if (status === INIT_ACCOUNTS_FAIL || status === EDIT_ACCOUNT_FAIL || status === SAVE_ACCOUNT_FORM_FAIL) {
    //     forwardLogin("Connect timeout, please relogin.");
    //     history.push("/Login");
    //   }
    // }
  // }

  render() {
    return this.renderList();
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    idToken: state.logindReducers.idToken,
    status: state.companyReducers.status,
    companyInfo: state.companyReducers.companyInfo,
    loading: state.companyReducers.loading
  }
}

export default withRouter(connect(
  mapStateToProps, 
  { forwardLogin, initCompanyData }
)(CompanyInfoPage))
